<template>
    <div class="hello" ref="chartdiv">
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    am4core.useTheme(am4themes_animated);


    export default {
        name: 'amchart-pie',
        props: {
            data: Array,
            series: Object
        },
        computed: {},
        mounted() {

            let chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart);

            chart.paddingRight = 20;

            chart.data = this.data;

            // Add series

            if(this.series !== null && typeof(this.series) !== 'undefined'){
                chart.series.push(this.series)
            } else {
                chart.series.push(new am4charts.PieSeries())
            }

        },

        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hello {
        width: 100%;
        height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/components/amcharts/amchart-pie.vue